/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MobileSskPublicKeyResponse } from '../models/MobileSskPublicKeyResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MobileSskService {
    /**
     * Get SSK public key
     * Fetch the public key components for the tenant's active SSK certificate
     * @param xMobileAuth
     * @returns MobileSskPublicKeyResponse Successful Response
     * @throws ApiError
     */
    public static getSskPublicKey(
        xMobileAuth?: (string | null),
    ): CancelablePromise<MobileSskPublicKeyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mobile/v1/ssk/public-key',
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
